import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { POADocumentType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface DeleteDocumentProps {
  importerId: string;
  fileName: string;
  type: POADocumentType;
}

export const useDeleteDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, fileName }: DeleteDocumentProps) => {
      const result = await apiClient.importer.deleteDocument.mutation({ params: { id: importerId, fileName } });
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
      toast.success(`${variables.type} document deleted!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting document!`);
    },
  });
};
